export default __webpack_public_path__ + "static/media/rocket_anim_32.b098fac1.png";